import React from 'react'
import { Form, Checkbox, DatePicker, Input, Select, Divider, Radio } from 'antd'
import { Message } from 'semantic-ui-react';

class CaseDocumentsForm extends React.Component {
  render() {
    return (
      <Form name="case-documents">
        <div className="fluid-field checkbox-field">
          <Checkbox>Request Sent to Provider</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 2
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Claimant Details</h3>
        <Form.Item 
          label={
            <React.Fragment>
              CR Provider
              <button className="field-actions">
                Add/Edit
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="CR Provider 2 (Doctor)">
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Email for Sending CR Request">
          <Input size="large" />
          <Checkbox style={{marginTop: 10}}>To be sent</Checkbox>
        </Form.Item>
        <Form.Item label="Email 2 for Sending CR Request">
          <Input size="large" />
          <Checkbox style={{marginTop: 10}}>To be sent</Checkbox>
        </Form.Item>
        <Form.Item label="Requested Completion Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Expected Completion Date
              <button className="field-actions">
                Send Completion Update to CMs
              </button>
            </React.Fragment>
          }
        >
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Case Documents</h3>
        <Form.Item label="Paperwork Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attach Letter of Authority (LOA)" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Attach Other Documents" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Request Comment" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Email LOA to CR Provider</Checkbox>
          <button className="field-actions">
            Resend LOA
          </button>
        </div>
        <Form.Item label="Send Paperwork by Other Methods" className="fluid-field">
          <Checkbox.Group>
            <Checkbox>Courier</Checkbox>
            <Checkbox>Dx</Checkbox>
            <Checkbox>Express Post</Checkbox>
            <Checkbox>FAX</Checkbox>
            <Checkbox>Standard Post</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Sending Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>CR Files Sent to CMs</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 5
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="CR Files Received by" className="fluid-field">
          <Radio.Group>
            <Radio>Email or electronic medium ($65 flat rate)</Radio>
            <Radio>Hard copy (postage) ($38, +$1.4/pp from 33rd page onwards)</Radio>
            <Radio>Fax</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="CR Files Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="CR File Sent Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <Form.Item label="View Remaining Unmerged Files" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Or Share Download Link" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Email CR Files to CMs</Checkbox>
          <button className="field-actions">
            Resend CR Files
          </button>
        </div>
      </Form>
    ) 
  }
}

export default CaseDocumentsForm